import React from 'react';
import { Box } from '@ublend-npm/aulaui-core';
import withErrorBoundary from '@app/components/presentational/common/ErrorBoundary/ErrorBoundary';
import SpaceWidgetSection from './SpaceWidgetSection';
import SpaceWidgetError from './SpaceWidgetError';

const SpaceWidgetErrorBoundaryFallback = () => (
  <Box width="100%" sx={{ minWidth: 0, maxWidth: '100%' }}>
    <SpaceWidgetError variant="api" onRetry={() => window.location.reload()} />
  </Box>
);

export default withErrorBoundary(SpaceWidgetSection, {
  FallbackComponent: SpaceWidgetErrorBoundaryFallback,
});
